import _ from "lodash";

export default mime => (!_.isNil(mime) && mime.indexOf("image") === -1 ? 0 : 1);
